<template>
  <div class="booking-box-need-to-upload">
    <div v-if="tempData.status">
      <div class="box1">
        <div class="item">
          <div class="title">Data</div>
          <div class="text" v-text="tempData.date"></div>
        </div>
        <div class="item">
          <dropdown-time-type-2
            v-model="tempData.reservation"
          ></dropdown-time-type-2>
        </div>
        <div class="item">
          <div class="title">Ref No.</div>
          <div class="text" v-text="tempData.id"></div>
        </div>
      </div>
      <div class="message-box" v-if="!uploadStatus">
        <div class="profile-image">
          <img v-imageLoading="tempData.userProfileImage" />
        </div>
        <div class="contents">
          <div class="author">
            Shooting with <span class="name" v-text="tempData.userName"></span>
          </div>
          <div class="comment" v-text="tempData.location.address.detail"></div>
        </div>
        <div class="uploaded buttons" v-if="tempData.uploaded">
          <base-button-type1
            text="VIEW UPLOAD PICTURE"
            @click="upload"
          ></base-button-type1>
        </div>
        <div class="buttons " v-else>
          <base-button-type1
            text="Message"
            @click="message"
          ></base-button-type1>
          <button class="upload" @click="upload">Upload</button>
        </div>
      </div>
      <div class="upload-box" v-else>
        <div class="upload-url">
          <base-input-type-new-1
            v-model="tempData.downloadUrl"
            placeholder="https://www.dropbox.com/s/an166gd6g8"
            label="Original image share link (e.g. dropbox share link)"
          ></base-input-type-new-1>
        </div>
        <div class="title">Upload pictures (Edited pictures)</div>
        <image-upload-type-new-1
          v-on:model="v => setUploadData(v)"
          directory="/reservation/uploaded"
          :importPreviewImages="tempData.uploaded"
        ></image-upload-type-new-1>
        <div class="button-box" v-if="uploadStatus">
          <base-button-type-1
            @click="cancel"
            text="CANCEL"
            style="background-color: #FFF; color: #000; border: 1px solid #eee"
          ></base-button-type-1>
          <base-button-type-1 text="OK" @click="save"></base-button-type-1>
        </div>
      </div>
    </div>

    <div class="no-data" v-else>
      <div class="message">There is no Message</div>
    </div>
  </div>
</template>

<script>
import ImageUploadTypeNew1 from './ImageUploadTypeNew1'
import BaseButtonType1 from './form-elemnets/BaseButtonType1'
import DropdownTimeType2 from './DropdownTimeType2'
import { createMessage } from '../../api/message'
import { setRequestReservation } from '../../api/reservation'
import BaseInputTypeNew1 from './form-elemnets/BaseInputTypeNew1'
import mixCommon from '../../mixin/common'

export default {
  mixins: [mixCommon],
  name: 'booking-box-need-to-upload',
  components: {
    BaseInputTypeNew1,
    DropdownTimeType2,
    BaseButtonType1,
    ImageUploadTypeNew1
  },
  props: {
    data: {
      default: () => ({
        date: '@/components/2018',
        time: '15:00 - 17:00',
        refNo: '213',
        profileImage: require('@/assets/images/common/temp-profile.jpg'),
        edit: false,
        status: true,
        comment:
          'at Chantrey House, 98 Buckingham Palace Rd, Belgravia, London SW1W 0SS',
        photographerName: 'Miky',
        uploaded: []
      }),
      type: Object
    }
  },
  data() {
    return {
      tempData: {},
      uploadStatus: false,
      uploadData: '',
      downloadUrl: ''
    }
  },
  created() {
    console.log(this.data)
    this.tempData = this.data
    this.tempData.time = '1:5'
  },
  methods: {
    setDownloadUrl(url) {
      this.downloadUrl = url
    },
    save() {
      console.log('save:', this.tempData.id, this.uploadData, this.downloadUrl)
      if (this.downloadUrl) {
        setRequestReservation(this.tempData.id, {
          uploaded: this.uploadData,
          downloadUrl: this.tempData.downloadUrl,
          status: 'uploaded'
        }).then(rst => {
          console.log(rst)
          this.cancel()
        })
      } else {
        alert('Input your download url')
      }
    },
    setUploadData(v) {
      console.log('set upload data:', v)
      this.uploadData = v
    },
    cancel() {
      this.uploadStatus = false
    },
    buttonAction(actionName) {
      this.$emit('action', { action: actionName, data: this.tempData })
    },
    upload() {
      this.uploadStatus = true
    },
    message() {
      // (photographerId, userId, serviceId, photographerProfileImage, userProfileImage)
      createMessage(
        this.tempData.photographerId,
        this.tempData.uid,
        this.tempData.id,
        this.tempData.photographerProfileImage,
        this.tempData.userProfileImage,
        this.tempData.userName,
        this.tempData.photographerName
      ).then(res => {
        console.log('message create response:', res)
        this.$router.push({ path: '/photographer/message/' + this.tempData.id })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.booking-box-need-to-upload {
  border: 1px solid #c8c8c8;
  .box1 {
    background-color: #f5f5f5;
    display: flex;
    border-bottom: 1px solid #c8c8c8;
    .item {
      width: 100%;
      height: 80px;
      &:nth-child(1) {
        border-right: 1px solid #c8c8c8;
      }

      &:nth-child(2) {
        border-right: 1px solid #c8c8c8;
      }

      .title {
        margin: 20px 0 0 20px;
        /*border: 1px solid red;*/
        font-weight: 600;
        font-size: 16px;
        letter-spacing: 1px;
      }

      .text {
        margin: 10px 0 0 20px;
        font-size: 16px;
        font-weight: 300;
        letter-spacing: 1px;
      }
    }
  }
  .message-box {
    display: flex;
    justify-content: space-between;
    .profile-image {
      width: 131px;
      height: 131px;
      position: relative;
      img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 100px;
        height: 100px;
      }
    }
    .contents {
      width: 70%;
      margin: 18px 0 18px 0;
      /*border: 1px dotted red;*/
      .author {
        font-weight: 600;
      }

      .comment {
        margin: 10px 0 0 0;
        width: 700px;
        height: 71px;
        /*border: 1px solid red;*/
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .buttons {
      width: 200px;
      display: flex;
      justify-content: space-evenly;
      flex-direction: column;
      align-items: center;
      button {
        width: 150px;
        height: 50px;
        font-size: 14px;
        font-weight: 300;
        letter-spacing: 1px;
        cursor: pointer;
        outline: none;
        &:first-child {
          margin: 6px 0 0 0;
          background-color: #ffffff;
          color: #000;
          border: 1px solid #eee;
        }
      }
      .upload {
        border: 0;
        background-color: #000bff;
        color: white;
        margin-bottom: 10px;
      }
    }
  }

  .upload-box {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: center;
    position: relative;
    height: 430px;

    .upload-url {
      margin: 10px 0 10px 0;
      width: 1040px;
    }

    .title {
      margin: 10px 0 0 0;
      width: 1040px;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 1px;
      color: #000000;
    }
    .image-upload-type-new-1 {
      margin: 10px 0;
      width: 1040px;
    }

    .button-box {
      position: relative;
      align-self: flex-end;
      margin: 0 16px 0 0;
      .base-button-type-1:first-child {
        margin: 0 10px 0 0;
      }
    }
  }
  .no-data {
    height: 200px;
    position: relative;
    .message {
      margin: auto;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 200px;
      text-align: center;
      height: 20px;
    }
    background-color: #f5f5f5;
  }
}
</style>
